export const DEFAULT_SEO_KEYWORDS = [
  `angular`,
  `javascript`,
  `typescript`,
  `web development`,
]; // Amazing
